import { IResearchPropertyPath } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export const getResearchWorkItemPath = async (
  workItemId: string
): Promise<IResearchPropertyPath> => {
  const response = await apiClient.get(
    `/research/work-items/${workItemId}/path`
  );

  return response.data;
};
